import React from 'react'

function AlertBanner(props) {
  return (
    <div
      className={'mx-auto alert alert-' + props.type}
      role='alert'
      style={props.style}
    >
      <h4 className='alert-heading'>
        <b>{props.heading}</b>
      </h4>
      <p>{props.body}</p>
    </div>
  )
}

export { AlertBanner }
